import axios from 'axios'

export const BOOKS = [{
  url: './mn001.json',
}, {
  url: './mn002.json',
}, {
  url: './mn003.json',
}, {
  url: './mn004.json',
}, {
  url: './kfb.json',
}]

export const  getBookData = async (url) => {
  try {
    const ret = await axios.get(url)
    if (ret.status === 200) {
      return ret.data
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
    return null
  }
}

